import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import { Link } from 'react-scroll'

import styles from './link-element.module.css'

const propTypes = {
    child: PropTypes.shape({
        props: PropTypes.shape({
            name: PropTypes.string.isRequired,
            navigationElementClassName: PropTypes.string,
            section: PropTypes.bool
        }).isRequired
    }).isRequired,
    containerId: PropTypes.string.isRequired
}

const defaultProps = {
    navigationElementClassName: ''
}

/**
 * Generation of the link navigation.
 *
 * @param {object} child - Properties for the configuration of the link
 * @param {string} containerId - The container id for every link element to which the element belongs to
 * @param {string} child.name - The display name of the link element
 * @param {boolean} child.navigationElementClassName - CSS Classname e.g. for t3sel selectors
 * @param {boolean} child.section - Determines if headline is a section headline
 * @returns {ReactElement}
 */
const LinkElement = ({ child, containerId }) => {
    const { name, navigationElementClassName, section } = child.props
    const composedClassName = cx(styles['link'], { [styles['link-headline']]: section }, navigationElementClassName)

    return (
        <li>
            <Link
                activeClass="activeScroll"
                className={composedClassName}
                to={name}
                spy
                smooth
                isDynamic
                containerId={containerId}
                duration={500}
            >
                {name}
            </Link>
        </li>
    )
}

LinkElement.propTypes = propTypes
LinkElement.defaultProps = defaultProps

export default LinkElement
